<template>
  <tr class="offer-item" @click.stop="openTransactions(item.public_id)">
    <td class="agreement" @click.stop="copyAgreementId">
      <span class="agreement-id">{{ item?.Agreement?.document_id }}</span>
      <svg height="16" viewBox="0 0 16 16" width="16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path stroke="#A7A7A7" d="M10.6673 8.59998V11.4C10.6673 13.7333 9.73398 14.6666 7.40065 14.6666H4.60065C2.26732 14.6666 1.33398 13.7333 1.33398 11.4V8.59998C1.33398 6.26665 2.26732 5.33331 4.60065 5.33331H7.40065C9.73398 5.33331 10.6673 6.26665 10.6673 8.59998Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
        <path stroke="#A7A7A7" d="M14.6673 4.59998V7.39998C14.6673 9.73331 13.734 10.6666 11.4007 10.6666H10.6673V8.59998C10.6673 6.26665 9.73398 5.33331 7.40065 5.33331H5.33398V4.59998C5.33398 2.26665 6.26732 1.33331 8.60065 1.33331H11.4007C13.734 1.33331 14.6673 2.26665 14.6673 4.59998Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
      </svg>
    </td>
    <td class="name" :title="userName">{{ userName }}</td>
    <td class="issued">
      {{ offerIssuedDate }}
    </td>
    <td class="amount">
      {{ item.got_money / 100 }}
    </td>
    <td class="term">
      {{ offerTerm }}
    </td>
    <td class="percent">
      {{ offerPercent }}
    </td>
    <td class="income">
      {{ item.initial_debt / 100 }}
    </td>
    <td class="issued-by">
      {{ offerIssueDate }}
    </td>
    <td class="peni">
      {{ item.total_penalty / 100 }}
    </td>
    <td class="total-amount">
      {{ (item.rest_debt) / 100 }}
    </td>
    <td class="status">
      <div :class="item.status">
        {{ $t(`message.profile.borrower.activeOffers.status.${item.status}`) }}
      </div>
    </td>
    <td class="pay" @click.stop>
      <div class="btn-block">
        <base-spinner
          v-if="isLastPaymentInProgress"
          :is-loading="true"
          :is-local="true"
          class="payment-progress-spinner"
          size="6px"
        />
        <template v-else>
          <base-button
            :text="$t(`message.profile.borrower.activeOffers.btn`)"
            class="pay-btn"
            @click="openPayModal()"
            v-if="isShowRegularPayBtn"
            :disabled="!profile.default_card_id"
            :minHeight="'auto'"
          />
          <base-button
            :text="$t('message.profile.borrower.activeOffers.signBtn')"
            class="sign-btn"
            @click="openContract()"
            v-if="isShowSignBtn"
            :minHeight="'auto'"
          />
          <div
            class="er-menu-wrap"
            v-if="isShowEarlyRepaymentMenu"
            v-click-outside="hideEarlyRepaymentMenu"
          >
            <img
              class="offer-menu-img"
              src="../../../public/custom/images/offer-menu.svg"
              alt="Offer menu image"
              @click.stop="toggleEarlyRepaymentMenu()"
            />
            <div class="offer-menu" v-if="isEarlyRepaymentMenuOpen">
              <div
                v-if="isShowNotifyMenu"
                class="offer-menu-item"
                @click.stop="openEarlyRepaymentNotify()"
              >
                {{ $t('message.profile.borrower.earlyRepayment.notifyBtn') }}
              </div>
              <div
                v-if="isShowEarlyPayBtn"
                class="offer-menu-item"
                :class="{ 'offer-menu-item-disabled': !profile.default_card_id }"
                @click.stop="openEarlyRepaymentPayFromMenu()"
              >
                {{ $t('message.profile.borrower.earlyRepayment.payBtn') }}
              </div>
            </div>
          </div>
          <div
            class="er-awaiting-icon"
            v-if="isLastPaymentFailed"
            title="Последний платеж не выполнен"
          >
            <img src="../../../public/custom/images/no-rate.svg" alt="Last payment failed">
          </div>
          <div
            class="er-awaiting-icon"
            v-if="isShowAwaitingIcon"
            :title="awaitingTooltip"
          >
            <img src="../../../public/custom/images/attention.png" alt="Early repayment notification sent">
          </div>
        </template>
        <div
          class="claim-sent-icon"
          v-if="isClaimSent"
          :title="claimSentTooltip"
          @click.stop
        >
          <img src="../../../public/custom/images/claim.svg" alt="Claim sent">
        </div>
        <div
          class="lawsuit-filed-icon"
          v-if="isLawsuitFiled"
          :title="lawsuitFiledTooltip"
          @click.stop
        >
          <img src="../../../public/custom/images/legal.svg" alt="Lawsuit filed">
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import BaseButton from '../../components/base/BaseButton.vue';
import BaseSpinner from '../../components/base/BaseSpinner.vue';
import ClickOutside from 'vue-click-outside';
import { mapGetters } from 'vuex';
import earlyRepaymentLoanItemMixin from '../../mixins/earlyRepaymentLoanItemMixin';

export default {
  name: "borrowerLoanItem",
  mixins: [earlyRepaymentLoanItemMixin],
  directives: {
    ClickOutside,
  },
  components: {
    BaseButton,
    BaseSpinner,
  },
  props: {
    item: Object,
  },
  data() {
    return {
      isPayBtnLoading: false,
    };
  },
  methods: {
    openPayModal() {
      this.$emit('openPayModal', {
        totalAmount: this.item.rest_debt,
        loan_public_id: this.item.public_id,
        initial_debt: this.item.initial_debt,
        total_penalty: this.item.total_penalty
      });
    },
    openEarlyRepaymentPayFromMenu() {
      if (!this.profile.default_card_id) {
        return;
      }

      this.openEarlyRepaymentPay();
    },
    openContract() {
      this.$router.push({
        name: 'contract',
        query: { agreement_id: this.item?.Agreement?.document_id }
      });
    },
    openTransactions(id) {
      this.$emit('openTransactions', id);
    },
    async copyAgreementId() {
      const agreementId = String(this.item?.Agreement?.document_id);

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(agreementId);
        } else {
          this.copyTextFallback(agreementId);
        }
      } catch (error) {
        this.copyTextFallback(agreementId);
      }

      this.$toast.success('Номер договора скопирован в буфер обмена');
    },
    copyTextFallback(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'absolute';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    },
  },
  computed: {
    ...mapGetters(['profile']),
    userName() {
      const lastName = this.item?.Offer?.MsiIndividualUser?.name_ru?.family_name_ru;
      const name = (this.item?.Offer?.MsiIndividualUser?.name_ru?.given_name_ru).slice(0, 1) + '.';

      return `${lastName} ${name}`;
    },
    offerIssuedDate() {
      return new Date(this.item?.createdAt).toLocaleDateString();
    },
    offerTerm() {
      return this.item?.Offer?.loan_term_days + 'д.';
    },
    offerPercent() {
      return this.item?.Offer?.annual_percent;
    },
    offerIssueDate() {
      return new Date(this.item?.due_date).toLocaleDateString();
    },
    isShowSignBtn() {
      return this.item.status === 'signing';
    },
    isLoanOverdue() {
      return this.item?.status === 'overdue';
    },
    isClaimSent() {
      return this.isLoanOverdue && this.item?.claim?.exists === true && this.item?.claim?.status === 'sent';
    },
    isLawsuitFiled() {
      return this.isLoanOverdue && this.item?.lawsuit?.filed === true;
    },
    claimSentTooltip() {
      const createdAt = this.item?.claim?.created_at;
      const date = createdAt ? new Date(createdAt) : null;

      if (!date || Number.isNaN(date.getTime())) {
        return 'Претензия отправлена';
      }

      return `Претензия отправлена ${date.toLocaleDateString('ru-RU')}`;
    },
    lawsuitFiledTooltip() {
      const filedAt = this.item?.lawsuit?.created_at;
      const date = filedAt ? new Date(filedAt) : null;

      if (!date || Number.isNaN(date.getTime())) {
        return 'Иск подан';
      }

      return `Иск подан ${date.toLocaleDateString('ru-RU')}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.offer-item {
  font-size: 0.895rem;
}

.offer-item td {
  font-size: 0.895rem;
}

.offer-item td.status {
  font-size: 12px;

  div {
    width: fit-content;
    white-space: nowrap;
  }
}

.agreement {
  color: #1a8d48;
  font-weight: 600;
  cursor: pointer;

  &:hover path {
    stroke: #1a8d48;
  }
}

.agreement-id {
  @include overflow-elipsis;
}

.agreement svg {
  margin-left: 6px;
  vertical-align: middle;
  flex-shrink: 0;
}

.btn-block {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
  height: 32px;
}

.pay {
  position: relative;
}

.er-menu-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.offer-menu-img {
  height: 22px;
  width: 22px;
  cursor: pointer;
}

.offer-menu {
  width: 220px;
  padding: 0;
  box-sizing: border-box;
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #cdcdcd;
  border-radius: 10px;
  font-size: 14px;
  line-height: 135%;
  color: #333333;
  overflow: hidden;
  z-index: 3;
}

.offer-menu-item {
  width: 100%;
  padding: 12px 15px;
  box-sizing: border-box;
  white-space: normal;
  cursor: pointer;

  &:not(:last-child) {
    border-bottom: 1px solid #eceef0;
  }

  &:hover {
    background: #f7f7f7;
  }
}

.offer-menu-item-disabled {
  color: rgba(51, 51, 51, 0.5);
  cursor: not-allowed;

  &:hover {
    background: #ffffff;
  }
}

.er-awaiting-icon {
  display: flex;
  align-items: center;
  cursor: help;

  img {
    width: 22px;
    height: 22px;
  }
}

.claim-sent-icon {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff1d5;
  border-radius: 50%;
  cursor: default;
}

.claim-sent-icon img {
  width: 15px;
  height: 15px;
}

.lawsuit-filed-icon {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffdbdb;
  border-radius: 50%;
  cursor: help;
}

.lawsuit-filed-icon img {
  width: 15px;
  height: 15px;
}

.payment-progress-spinner {
  width: 22px;
  height: 22px;
  margin: 0 auto;
}

.payment,
.on_due,
.current_debt,
.payment_pending {
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #CB7723;
  background: #FFF1D5;
  border-radius: 6px;
}

.closed,
.paid,
.repaid {
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #21A15C;
  background: #D6F9D3;
  border-radius: 6px;
}

.expired,
.overdue,
.payment_failed {
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #C93434;
  background: #FFDBDB;
  border-radius: 6px;
}

.signing {
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #214ea1;
  background: #d3e5f9;
  border-radius: 6px;
}

.canceled {
  padding: .3rem .7rem;
  box-sizing: border-box;
  color: #6b6b6b;
  background: #eceef0;
  border-radius: 6px;
}

.sign-btn ::v-deep {
  border-radius: 6px;
}

.pay-btn ::v-deep {
  background-color: white;
  border: 2px solid #41BF7B;
  border-radius: 6px;
  color: #41BF7B;
  padding: 0;
  font-size: calc(8px + 8 * (100vw / 1920));
  font-weight: 600;

  &:hover {
    background-color: #41BF7B;
    color: white;
  }

  &.disabled {
    background-color: rgba(255, 255, 255, 0.5);
    border: 2px solid rgba(64, 191, 123, 0.5);
    color: rgba(64, 191, 123, 0.5);
  }

  &.disabled:hover {
    background-color: rgba(255, 255, 255, 0.5);
    border: 2px solid rgba(64, 191, 123, 0.5);
    color: rgba(64, 191, 123, 0.5);
  }
}

</style>
